<div class="label {{ variant }} {{ variant }}-{{ size }}" type="button" (click)="onClick()" (keyDown)="onKeyDown()">
	<ng-content />
	<ng-content select="mat-icon" />
</div>
